import { render, staticRenderFns } from "./ContratView.vue?vue&type=template&id=44322db6&"
import script from "./ContratView.vue?vue&type=script&lang=js&"
export * from "./ContratView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports